import App from "./pages/App.vue";
import auth from "./auth";
import axios from "axios";
import ComponentsPlugin from "@/components/extended/components-plugin";
import FloatingVue from "floating-vue";
import router from "./router";
import socket from "./socket";
import store from "./store";
import Toast, { useToast } from "vue-toastification";
import UComponentsPlugin from "@/components/uikit/components-plugin";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import VueYandexMetrika from "vue3-yandex-metrika";
import { ConfirmationService } from "primevue";
import { createApp } from "vue";
import { createGtm } from "@gtm-support/vue-gtm";
import { getFingerprint } from "@/help/fingerprint";
import { TonConnectUIPlugin } from "@townsquarelabs/ui-vue";
import { initTheme } from "./help/themeManager";
import notificationsController from "@/help/notificationsController";
import "@/assets/scss/main.scss";
import "bootstrap/dist/css/bootstrap.css";
import "vue-toastification/dist/index.css";
import i18n from "./localization/localization";
import Aura from "@primeuix/themes/aura";
import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";
import "./envSchema";
const options = {
    // manifestUrl: "http://localhost:8080/ton-connect/tonconnect-manifest_local.json" // for local testing
    manifestUrl: process.env.VUE_APP_MANIFEST_URL || "https://cabinet.stg.autentic.capital/ton-connect/tonconnect-manifest.json"
};
const toastTimeout = 5000;
const toastOptions = {
    timeout: toastTimeout,
    position: "top-right",
    closeOnClick: true,
    pauseOnFocusLoss: true,
    closeButton: false,
    toastDefaults: {
        toastClassName: "my-custom-toast"
    },
    filterBeforeCreate: (toast, toasts) => {
        if (toast.showInMenu !== false) {
            const uniqueId = new Date().getTime().toString() + toast.id;
            const userId = auth?.user()?.id;
            if (userId) {
                notificationsController.addNotification(uniqueId, toast.type, toast.content, !document.hidden, userId);
            }
        }
        if ((toast.showInMenu == false && toasts.filter(t => t.content === toast.content).length !== 0) || document.hidden) {
            return false;
        }
        return toast;
    },
    filterToasts: (toasts) => {
        const maxVisibleToasts = 2;
        if (toasts.length > maxVisibleToasts) {
            toasts.slice(0, -maxVisibleToasts).forEach(t => {
                t.closed = true;
            });
        }
        return toasts.filter(t => !t.closed).slice(-maxVisibleToasts);
    }
};
const app = createApp(App)
    .use(store)
    .use(TonConnectUIPlugin, options)
    .use(router)
    .use(ComponentsPlugin)
    .use(UComponentsPlugin)
    .use(Toast, toastOptions)
    .use(i18n)
    .use(vClickOutside)
    .use(VueAxios, axios)
    .use(FloatingVue)
    .use(auth)
    .use(socket)
    .use(VueCookies, { expires: "14d" })
    .use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: ".app-dark"
        }
    }
})
    .use(ConfirmationService)
    .component("Apexchart", VueApexCharts);
initTheme();
const toast = useToast();
app.config.globalProperties.$toast = toast;
app.provide("toast", app.config.globalProperties.$toast);
app.axios.defaults.withCredentials = true;
app.axios.defaults.baseURL = process.env.VUE_APP_HOST_API;
app.axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response) {
        const status = error.response.status;
        if (status == 500) {
            toast.error("Server error during the request", { showInMenu: false });
        }
    }
    return Promise.reject(error);
});
app.axios.interceptors.request.use(async (config) => {
    const fp = await getFingerprint();
    config.headers["X-Client-Fingerprint"] = fp;
    return config;
});
app.config.globalProperties.$filters = {
    correctETH(eth) {
        return /^0x[a-fA-F0-9]{40}$/.test(eth);
    },
    shortAddress: (address) => {
        return address ? address.substr(0, 5) + "..." + address.substr(-5) : "";
    }
};
if (process.env.NODE_ENV === "production") {
    app.use(VueYandexMetrika, {
        id: process.env.VUE_APP_ANALYTICS_YANDEX_KEY,
        router: router,
        env: process.env.NODE_ENV,
        options: {
            clickmap: false
        }
    });
    app.use(createGtm({
        id: process.env.VUE_APP_ANALYTICS_GOOGLE_KEY
    }));
}
app.mount("#app");
import "bootstrap/dist/js/bootstrap.js";
import "floating-vue/dist/style.css";
